











































import {Vue, Component} from 'vue-property-decorator';
import Table from '@/components/Table.vue';
import AdminGatewayTypeService from '@/services/admin.gatewaytype.service';

@Component({
  components: {Table},
})
export default class AdminGatewayTypes extends Vue {
  private search: string = '';
  private options: any = { itemsPerPage: 25 };
  private gatewayTypes: any[] = [];

  private tableData: any = {
    headers: [
      {text: 'Name', value: 'name', align: 'start'},
      {text: 'Slug', value: 'slug', align: 'start'},
      {text: '', value: 'actions', sortable: false, width: '5%'},
    ],
    rows: [],
    total: 0,
  };

  private async mounted() {
    await this.getAllGatewayTypes();
  }


  private async addGatewayType() {
    this.$router.push('/admin/settings/gatewayType/new');
  }

  private goToEdit(row: any) {
    if (row.path) {
      this.$router.push({ path: row.path });
    }
  }

  private async getAllGatewayTypes() {
    this.gatewayTypes = await AdminGatewayTypeService.getSystemGatewayTypes();
    this.tableData.rows = this.gatewayTypes;

    this.tableData.rows.forEach((row: any) => {
      row.path = `/admin/settings/gatewayType/${row.id}`;
    });
  }
}
